// Website related settings
const settings = {
    isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
    title: "Hello,",
    nickname: "I am Murari Goswami",
    logo_name: "",
    subTitle:
        "A passionate data driven individual, experienced with building end to end products in AI, Machine Learning, data engineering/ science, cloud architecture with state of the art design and technologies.",
    resumeLink:
        "https://www.linkedin.com/in/murari/",
    portfolio_repository: "https://github.com/murari-goswami",
};

const socialMediaLinks = {
    /* Your Social Media Link */
    github: "https://github.com/murari-goswami",
    linkedin: "https://www.linkedin.com/in/murari/",
    gmail: "murari.it@gmail.com",
    twitter: "https://twitter.com/murarigoswami",
};

const skills = {
    data: [
        {
            title: "Data Science & AI",
            fileName: "DataScienceImg",
            skills: [
                "⚡ Developing highly scalable production ready models for various Deep Learning and Optimization use cases",
                "⚡ Experienced with modelling and factorizing Computer Vision and NLP products and run them in production",
                "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
                "⚡ Applied machine learning with feature engineering, scaling and augmentations",
            ],
            softwareSkills: [
                {
                    skillName: "Research-Gate",
                    fontAwesomeClassname: "simple-icons:researchgate",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Tensorflow",
                    fontAwesomeClassname: "logos-tensorflow",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Keras",
                    fontAwesomeClassname: "simple-icons:keras",
                    style: {
                        backgroundColor: "white",
                        color: "#d00000",
                    },
                },
                {
                    skillName: "PyTorch",
                    fontAwesomeClassname: "logos-pytorch",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Python",
                    fontAwesomeClassname: "ion-logo-python",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "Spark",
                    fontAwesomeClassname: "cib:apache-spark",
                },
                {
                    skillName: "Flasks",
                    fontAwesomeClassname: "simple-icons:flask",
                },
                {
                    skillName: "Django",
                    fontAwesomeClassname: "logos-django",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "Jupyter",
                    fontAwesomeClassname: "logos-jupyter",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "D3-JS",
                    fontAwesomeClassname: "logos-d3",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "R",
                    fontAwesomeClassname: "logos-r-lang",
                },
            ],
        },
        {
            title: "Cloud Infra-Architecture",
            fileName: "CloudInfraImg",
            skills: [
                "⚡ Experience working on multiple cloud platforms viz AWS, GCP, Heroku, Digital Ocean, Azure",
                "⚡ Use of cloud formation scripts for Hosting and maintaining applications on virtual machine instances",
                "⚡ Deploying deep learning models on cloud and in distributed cluster for fast inference",
                "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
                "⚡ Event driven architecture and message passing for reactive application on cloud",
            ],
            softwareSkills: [
                {
                    skillName: "GCP",
                    fontAwesomeClassname: "simple-icons:googlecloud",
                    style: {
                        color: "#4285F4",
                    },
                },
                {
                    skillName: "AWS",
                    fontAwesomeClassname: "logos:aws"
                },
                {
                    skillName: "Azure",
                    fontAwesomeClassname: "simple-icons:microsoftazure",
                    style: {
                        color: "#0089D6",
                    },
                },
                {
                    skillName: "Docker",
                    fontAwesomeClassname: "simple-icons:docker",
                    style: {
                        color: "#1488C6",
                    },
                },
                {
                    skillName: "Ansible",
                    fontAwesomeClassname: "simple-icons:ansible",
                },
                {
                    skillName: "Kubernetes",
                    fontAwesomeClassname: "simple-icons:kubernetes",
                    style: {
                        color: "#326CE5",
                    },
                },
                {
                    skillName: "Heroku",
                    fontAwesomeClassname: "simple-icons:heroku",
                    style: {
                        color: "#326CE5",
                    },
                },
            ],
        },
        {
            title: "Data Engineering and Analytics",
            fileName: "DataEngineeringImg",
            skills: [
                "⚡ Building E2E production data pipeline with CICD and nested orchestration",
                "⚡ Experienced with handling of structured, unstructured data in both batch and streaming channels",
                "⚡ Creating data product application for easy consumption and harmonized data models",
                "⚡ Hands on experience with distributed computing both in on prem as well as cloud infrastructure",
            ],
            softwareSkills: [
                {
                    skillName: "spark",
                    fontAwesomeClassname: "cib:apache-spark",
                },
                {
                    skillName: "Scala",
                    fontAwesomeClassname: "logos-scala",
                },
                {
                    skillName: "Java",
                    fontAwesomeClassname: "logos-java",
                },
                {
                    skillName: "airflow",
                    fontAwesomeClassname: "logos-airflow",
                },
                {
                    skillName: "Jenkins",
                    fontAwesomeClassname: "logos-jenkins",
                },
                {
                    skillName: "python",
                    fontAwesomeClassname: "logos-python",
                },
                {
                    skillName: "Hadoop",
                    fontAwesomeClassname: "logos-hadoop",
                },
                {
                    skillName: "Kafka",
                    fontAwesomeClassname: "mdi-apache-kafka",
                    style: {
                        backgroundColor: "transparent",
                        color: "#dc2f02",
                    },
                },
                {
                    skillName: "AWS EMR",
                    fontAwesomeClassname: "logos-aws-ec2",
                },
                {
                    skillName: "AWS S3",
                    fontAwesomeClassname: "logos-aws-s3",
                },
                {
                    skillName: "AWS kinesis",
                    fontAwesomeClassname: "logos-aws-kinesis",
                },
                {
                    skillName: "AWS sqs",
                    fontAwesomeClassname: "logos-aws-sqs",
                },
                {
                    skillName: "AWS lambda",
                    fontAwesomeClassname: "logos-aws-lambda",
                },
                {
                    skillName: "AWS rds",
                    fontAwesomeClassname: "logos-aws-rds",
                },
                {
                    skillName: "Google Data Proc",
                    fontAwesomeClassname: "logos-googledcloud",
                },
            ],
        },
        {
            title: "Backend Development",
            fileName: "FullStackImg",
            skills: [
                "⚡ Building reactive applications in batch",
                "⚡ Large scale extraction software products with Spring boot, elastic search and aws stack ",
                "⚡ Creating application backend in Flask and Django",
                "⚡ TDD and BDD product delivery",
            ],
            softwareSkills: [
                {
                    skillName: "Spring 5",
                    fontAwesomeClassname: "logos-spring",
                },
                {
                    skillName: "Swagger",
                    fontAwesomeClassname: "simple-icons:swagger",
                },
                {
                    skillName: "Git",
                    fontAwesomeClassname: "simple-icons:git",
                },
                {
                    skillName: "Oracle",
                    fontAwesomeClassname: "simple-icons:oracle",
                    style: {
                        color: "RED",
                    },
                },
                {
                    skillName: "SAP HAna",
                    fontAwesomeClassname: "simple-icons:sap",
                },
                {
                    skillName: "Yarn",
                    fontAwesomeClassname: "simple-icons:yarn",
                    style: {
                        color: "#2C8EBB",
                    },
                },
                {
                    skillName: "Gatsby",
                    fontAwesomeClassname: "simple-icons:gatsby",
                    style: {
                        color: "#663399",
                    },
                },
                {
                    skillName: "Flutter",
                    fontAwesomeClassname: "simple-icons:flutter",
                    style: {
                        color: "#02569B",
                    },
                },
            ],
        },
    ],
};

// Education Page
const competitiveSites = {
    competitiveSites: [
        {
            siteName: "Kaggle",
            iconifyClassname: "simple-icons:kaggle",
            style: {
                color: "#20BEFF",
            },
            profileLink: "https://www.kaggle.com/goswamimurari",
        },
        {
            siteName: "Driven Data",
            iconifyClassname: "flat-color-icons:database",
            style: {
                backgroundColor: "transparent",
                color: "#D35400",
            },
            profileLink: "https://www.drivendata.org/users/murarigoswami/",
        },
        {
            siteName: "Driven Data",
            iconifyClassname: "logos-ai",
            style: {
                backgroundColor: "transparent",
                color: "#D35400",
            },
            profileLink: "https://www.aicrowd.com/participants/murari_goswami",
        },
    ],
};

const degrees = {
    degrees: [
        {
            title: "Cardiff Metropolitan University",
            subtitle: "MBA",
            logo_path: "cmu.jpg",
            alt_name: "CMU",
            duration: "",
            descriptions: [
                "⚡ I have studied Entrepreneurship, Analytics, Corporate Finance, International Business with thesis on each of them",
                "⚡ I also studied  Digital Marketing and wrote my thesis on this.",
            ],
            website_link: "https://www.cardiffmet.ac.uk/Pages/default.aspx",
        },
        {
            title: "Government College of Engineering and Ceramic Technology",
            subtitle: "B.Tech. in Computer Engineering",
            logo_path: "gcect.png",
            alt_name: "GCECT",
            duration: "",
            descriptions: [
                "⚡ I have studied core concepts like Engineering Mathematics, Data Mining, Numerical Computing, Operations Research, Control theory, Statistics and Probability Theory, Robotics",
                "⚡ In computer science I have studied subjects like DS, Algorithms, DBMS, OS, CA, AI, Ubiquitous computing etc.",
                "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in university.",
            ],
            website_link: "http://gcect.ac.in/",
        },
    ],
};

const certifications = {
    certifications: [
        {
            title: "Machine Learning",
            subtitle: "- Andrew Ng",
            logo_path: "stanford_logo.png",
            certificate_link: "",
            alt_name: "Stanford University",
            color_code: "#b4bcd2",
        },
        {
            title: "Deep Learning",
            subtitle: "- Andrew Ng",
            logo_path: "deeplearning_ai_logo.png",
            certificate_link: "",
            alt_name: "deeplearning.ai",
            color_code: "#b4bcd2",
        },
        {
            title: "NOC: Deep Learning ",
            subtitle: "- NPTEL (IIT Bombay)",
            logo_path: "nptel_logo.png",
            certificate_link: "",
            alt_name: "NPTEL",
            color_code: "#b4bcd2",
        },
        {
            title: "Application of Geospatial Technologies",
            subtitle: "- IIRS (ISRO)",
            logo_path: "isro.png",
            certificate_link: "",
            alt_name: "ISRO",
            color_code: "#b4bcd2",
        },
        {
            title: "Practical Deep Learning For Coders, V3",
            subtitle: "- Jeremy Howard",
            logo_path: "fast-ai.jpeg",
            certificate_link: "",
            alt_name: "Fast.AI",
            color_code: "#b4bcd2",
        },
        {
            title: "Google Training - Practical Machine Learning With Tensorflow",
            subtitle: "- Google",
            logo_path: "nptel_logo.png",
            certificate_link: "",
            alt_name: "NPTEL",
            color_code: "#b4bcd2",
        },
        {
            title: "The Data Scientist’s Toolbox",
            subtitle: "- John Hoppkins",
            logo_path: "john_hoppkins.jpg",
            certificate_link: "",
            alt_name: "John Hoppkins",
            color_code: "#b4bcd2",
        },
        {
            title: "Prince 2",
            subtitle: "- APMG (project management)",
            logo_path: "prince2.png",
            certificate_link: "",
            alt_name: "APMG",
            color_code: "#b4bcd2",
        },
        {
            title: "The Complete Neural Network Bootcamp",
            subtitle: "- Udemy",
            logo_path: "udemy.jpeg",
            certificate_link: "",
            alt_name: "UDEMY",
            color_code: "#b4bcd2",
        },
        {
            title: "Discrete Optimization",
            subtitle: "- Pascal Van Hentenrycky",
            logo_path: "melbourne.png",
            certificate_link: "",
            alt_name: "Melbourne University",
            color_code: "#b4bcd2",
        },
        {
            title: "Sequences, Time Series and Prediction",
            subtitle: "- Laurence Moroney",
            logo_path: "deeplearning_ai_logo.png",
            certificate_link: "",
            alt_name: "deeplearning.ai",
            color_code: "#b4bcd2",
        },
        {
            title: "TensorFlow in Practice",
            subtitle: "- Laurence Moroney",
            logo_path: "deeplearning_ai_logo.png",
            certificate_link: "",
            alt_name: "deeplearning.ai",
            color_code: "#b4bcd2",
        },
        {
            title: "IoT Foundation: Fundamentals",
            subtitle: "- Linkedin",
            logo_path: "linked-in.png",
            certificate_link: "",
            alt_name: "linkedin",
            color_code: "#b4bcd2",
        },
        {
            title: "Digital Image Processing",
            subtitle: "- IIRS (ISRO)",
            logo_path: "isro.png",
            certificate_link: "",
            alt_name: "ISRO",
            color_code: "#b4bcd2",
        },
        {
            title: "Deep Learning for Visual Computing",
            subtitle: "- IIT KGP",
            logo_path: "nptel_logo.png",
            certificate_link: "",
            alt_name: "IIT KGP",
            color_code: "#b4bcd2",
        },
        {
            title: "Remote Sensing Essentials",
            subtitle: "- IIT Roorkee",
            logo_path: "nptel_logo.png",
            certificate_link: "",
            alt_name: "IIT Roorkee",
            color_code: "#b4bcd2",
        },
        {
            title: "Extreme Gradient Boosting with XGBoost",
            subtitle: "- DataCamp",
            logo_path: "datacamp.png",
            certificate_link: "",
            alt_name: "DatacCmp",
            color_code: "#b4bcd2",
        },
        {
            title: "Deep Learning: GANs and Variational Autoencoders",
            subtitle: "- Udemy",
            logo_path: "udemy.jpeg",
            certificate_link: "",
            alt_name: "UDEMY",
            color_code: "#b4bcd2",
        },
    ],
};

// Experience Page
const experience = {
    title: "Experience",
    subtitle: "Work and Community",
    description:
        "I have worked in Adidas and Telefonica O2 UK in my last 13 years of experience. My expertise spans from data analytics engineering, data science, deep learning, and software engineering. " +
        "I have also mentored junior engineers. I have operated in UK, Singapore and germany",
    header_image_path: "experience.svg",
    sections: [
        {
            title: "Work",
            experiences: [
                {
                    title: "Sr. Data Engineer",
                    company: "Adidas AG",
                    company_url: "www.adidas.de",
                    logo_path: "adidas.png",
                    duration: "August 2015 - PRESENT",
                    location: "Herzogenaurach, Germany",
                    description:
                        "Data and Machine Learning Engineering:\n" +
                        "Lead in the implementation and factorization of image feature extraction from apparel (viz. logo, material, neck, sleeve, colour, texture detection) through deep learning (Tensorflow, Keras, hyperparameter tuning) in model creation and using spark in AWS for inferencing.\n" +
                        "Data Pipeline - Adidas asset (Product image) data pipeline to a data lake (AWS S3) through AWS stack and python with metadata-driven from Oracle database.\n" +
                        "Marketing Mix Modelling - Automated data collection, integration, cleansing, harmonisation and feature engineering in Spark scala for various media expenditure and conversion factor.\n" +
                        "Architecture and Development:\n" +
                        "Setup adidas global data lake in AWS cloud set up with EMR,  S3, Glue catalogue.\n" +
                        "Designed and implemented varied reactive micro-services architecture with Kafka, Spark, Spring boot/ cloud, Akka to support batch and realtime data pipeline and data lake algorithms. \n" +
                        "Co-author of open source automated metadata-driven big data asset creation framework M3D in Adidas. (https://github.com/adidas/m3d-engine.git and https://github.com/adidas/m3d-api.git)\n" +
                        "Use AWS stack in data lake development with EC2, EMR, RDS, Redshift, Lambda, SQS, Kinesis, Alexa Skills.\n" +
                        "Worked in leading the team of junior engineers (3) with implementations, upskilling and feedback in various product building processes\n" +
                        "\n" +
                        "Impact::\n" +
                        "Global image features in the data lake, used by multiple use cases like 'Product recommendation, demand and sales forecasting for future articles'.\n" +
                        "Cost-saving by 50% while creating and running the governed model by automated data pipeline delivery and optimized cloud infrastructure usage.\n" +
                        "\n" +
                        "Recognitions::\n" +
                        "Appreciations for creating and open-sourcing the M3D governed data discipline. \n" +
                        "Accolades for cutting edge solution in image feature extraction and made it usable across the company.",
                    color: "#14213d",
                },
                {
                    title: "Lear Software Engineer",
                    company: "Telefonica O2 UK",
                    company_url: "www.o2.co.uk",
                    logo_path: "o2.jpeg",
                    duration: "July 2007 - Aug 2015",
                    location: "Londn, UK",
                    description:
                        "Data Analytic solutions and product implementation through open source technologies.\n" +
                        "Data Hub product builds in Spark, Scala, Hive, Python, Oracle, Java.\n" +
                        "Delivered analytic solutions to make the data-driven decision making.\n" +
                        "Restful API through Spring, Java for a decision support system to run in multiple business propositions.\n" +
                        "Lead engineer with 4 junior engineers/ developers for various deliveries. Responsible for their tracking, up-skilling and feedback.\n" +
                        "\n" +
                        "Use Case Delivered : \n" +
                        "1. Prepay base churn - customer churn calculation though large and varied scale data processing and predict churn through regression analysis though enable methods like XGBoost.\n" +
                        "2. Telefonica O2 UK Loyalty Programme for complete Prepay User Base run through regression analysis.\n" +
                        "3. Smart Metering - an initiative by UK Gov to control power usage by an individual consumer.\n" +
                        "4. Contextual Marketing for Prepay Consumer base - analytics on CDR usage, Billing pattern, Bundle subscriptions.\n" +
                        "5. O2 Money: Omnichannel analytics \n" +
                        "6. Analytics for multiple propositions: Favorite Place, Your Country, Bonzono etc.\n" +
                        "7. Smart Steps: Body sensor IoT data collection, storage and ML recommendation using ML.",
                    color: "#14213d",
                },
            ],
        },
        {
            title: "Community Contributions",
            experiences: [
                {
                    title: "M3D",
                    company: "M3D - Adidas",
                    company_url: "https://github.com/adidas/m3d-api",
                    logo_path: "m3d_logo.png",
                    duration: "Apr 2016 - Present",
                    location: "Herzogenaurach, Germany",
                    description:
                        "I co-authored M3D and automation framework for big data engineering and machine learning algorithm building framework.",
                    color: "#fca31177",
                },
                {
                    title: "London Big Data Meetups",
                    company: "Meetup",
                    company_url: "https://www.meeptup.com/",
                    logo_path: "Meetup_Logo.png",
                    duration: "June 2012 - Apr 2015",
                    location: "London UK",
                    description:
                        "Participate and organize multiple Big data meetups and seminars in London Uk. Sometime this is also sponsored by various Tech Org.",
                    color: "#fca31177",
                },
                {
                    title: "Erlangen AI Meetup",
                    company: "Meetup",
                    company_url: "https://www.meeptup.com/",
                    logo_path: "Meetup_Logo.png",
                    duration: "Aug 2016 - Present",
                    location: "Erlangen, Germany",
                    description:
                        "Participate and organize multiple AI meetups in Erlangen Germany.",
                    color: "#fca31177",
                },
                {
                    title: "Developer Program Member",
                    company: "Github",
                    company_url: "https://github.com/",
                    logo_path: "github_logo.png",
                    duration: "July 2010 - PRESENT",
                    location: "Work From Home",
                    description:
                        "   I am actively contributing to many opensource projects. I have contributed to projects of organisations like Adidas M3D, Hadoop Hive, Vision Blitz ML models etc.",
                    color: "#fca31177",
                },
            ],
        },
    ],
};

// Projects Page
const projectsHeader = {
    title: "Projects",
    description:
        "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
    avatar_image_path: "projects-ai.svg",
};

// Talks Page
const talksHeader = {
    title: "Talks and Podcasts",
    description:
        "Details of my online talks and podcasts.",
    avatar_image_path: "talks.png",
};

// Contact Page
const contactPageData = {
    contactSection: {
        title: "Contact Me",
        profile_image_path: "murari.png",
        description:
            "I am available on various social media. You can reach me for consultation or discussions on ML, AI, SE, DE, DS, Cloud and Opensource Development.",
    },
    blogSection: {
        title: "Blogs",
        subtitle:
            "I write blogs to pen down my research, learnings, talks and sharing experiences.",
        link: "https://murarigoswami.wordpress.com/author/murarigoswami/",
        avatar_image_path: "blogs_image.svg",
    },
    addressSection: {
        title: "Residence",
        subtitle: "Germany",
        avatar_image_path: "address_image.svg",
        // location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
    },
    phoneSection: {
        title: "Phone Number",
        subtitle: "on-demamd",
    },
    emailSection: {
        title: "Email ID",
        subtitle: "murari_goswami@hotmail.com",
    },
};

export {
    settings,
    greeting,
    socialMediaLinks,
    skills,
    competitiveSites,
    degrees,
    certifications,
    experience,
    projectsHeader,
    contactPageData,
    talksHeader
};
